import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-33be9cd5")

_pushScopeId("data-v-33be9cd5")
const _hoisted_1 = { style: {"margin":"16px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 提交 ")
const _hoisted_3 = { class: "total" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 统计周期:每周四 00:00 至 下周三 23:59 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 1.本周总工时 : ")
const _hoisted_6 = { class: "tag" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 2.本周处理的Case数量 : ")
const _hoisted_8 = { class: "tag" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 3.本周处理过的问题类型 : ")
const _hoisted_10 = { class: "operation" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 跳转客户 Jira Filter Dashboard ")
const _hoisted_12 = { class: "common_popup_ul" }
const _hoisted_13 = {
  class: "common_popup_ul",
  style: {"width":"80vw"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_stepper = _resolveComponent("van-stepper")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_form = _resolveComponent("van-form")
  const _component_van_tag = _resolveComponent("van-tag")
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_van_form, {
      onSubmit: _ctx.onSubmit,
      class: "van-form"
    }, {
      default: _withId(() => [
        _createVNode(_component_van_field, {
          modelValue: _ctx.state.component,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.component = $event)),
          name: "component",
          label: "Component",
          readonly: "",
          clickable: "",
          placeholder: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.showComponentPicher = true)),
          rules: [{ required: true, message: '请选择Component' }]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          modelValue: _ctx.state.vid,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.vid = $event)),
          name: "vid",
          label: "VID",
          readonly: "",
          clickable: "",
          placeholder: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.showVidPicher = true)),
          rules: [{ required: true, message: '请选择VID' }]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          name: "time",
          label: "工时/小时",
          rules: [{ required: true, message: '请填写工时' }]
        }, {
          input: _withId(() => [
            _createVNode(_component_van_stepper, {
              min: "0",
              "decimal-length": "1",
              modelValue: _ctx.state.time,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.time = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_field, {
          name: "count",
          label: "Case数量",
          rules: [{ required: true, message: '请填写Case数量' }]
        }, {
          input: _withId(() => [
            _createVNode(_component_van_stepper, {
              min: "0",
              "decimal-length": "0",
              integer: "",
              modelValue: _ctx.state.count,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.count = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_field, {
          modelValue: _ctx.state.description,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.description = $event)),
          type: "textarea",
          rows: "3",
          name: "description",
          label: "问题描述",
          "show-word-limit": "",
          autosize: "",
          maxlength: "1000"
        }, null, 8, ["modelValue"]),
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            "native-type": "submit",
            loading: _ctx.state.submiting,
            "loading-text": "提交中..."
          }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    _createVNode("div", _hoisted_3, [
      _createVNode("h4", null, [
        _hoisted_4,
        _createVNode(_component_van_button, {
          icon: "replay",
          round: "",
          onClick: _ctx.fetchWorkHourJira,
          type: "primary",
          class: 
          _ctx.state.refreshing ? 'refreshBtn animation-rotating' : 'refreshBtn'
        ,
          disabled: _ctx.state.refreshing,
          size: "mini"
        }, null, 8, ["onClick", "class", "disabled"])
      ]),
      _createVNode("p", null, [
        _hoisted_5,
        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.state.resolvedTime.toFixed(2)) + "h", 1)
      ]),
      _createVNode("p", null, [
        _hoisted_7,
        _createVNode("span", _hoisted_8, _toDisplayString(_ctx.state.resolvedCount), 1)
      ]),
      _createVNode("p", null, [
        _hoisted_9,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.resolvedComponents, (item) => {
          return (_openBlock(), _createBlock(_component_van_tag, {
            type: "danger",
            size: "large",
            key: item
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(item), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", {
          class: "link",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openFilter && _ctx.openFilter(...args)))
        }, [
          _createVNode(_component_van_icon, { name: "share-o" }),
          _hoisted_11
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.state.showComponentPicher,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.showComponentPicher = $event)),
      position: "right"
    }, {
      default: _withId(() => [
        _createVNode("ul", _hoisted_12, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.componentOpts, (item) => {
            return (_openBlock(), _createBlock("li", {
              key: item,
              class: item === _ctx.state.component && 'active',
              onClick: 
          () => {
            _ctx.onComponentConfirm(item);
          }
        
            }, _toDisplayString(item), 11, ["onClick"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.state.showVidPicher,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.showVidPicher = $event)),
      position: "right"
    }, {
      default: _withId(() => [
        _createVNode("ul", _hoisted_13, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.vidOptions, (item) => {
            return (_openBlock(), _createBlock("li", {
              key: item.value,
              class: item.value === _ctx.state.vid && 'active',
              onClick: 
          () => {
            _ctx.onVidConfirm(item.value);
          }
        
            }, _toDisplayString(item.text), 11, ["onClick"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
})